import { useEffect } from 'react'

const SYNCFUSION_TOOLTIP_SELECTOR =
  '.e-tooltip-wrap, .e-tooltip-popup, .e-tooltip.e-popup'

const hideTooltipElement = (tooltip: Element): void => {
  const node = tooltip as HTMLElement
  node.classList.remove('e-popup-open')
  node.classList.add('e-popup-close')
  node.setAttribute('aria-hidden', 'true')
  node.style.visibility = 'hidden'
  node.style.opacity = '0'
  node.style.pointerEvents = 'none'
}

export const cleanupSyncfusionOrphanedTooltips = (): void => {
  const tooltips = document.querySelectorAll(SYNCFUSION_TOOLTIP_SELECTOR)
  if (tooltips.length === 0) return

  tooltips.forEach((tooltip) => {
    const tooltipElement = tooltip as HTMLElement
    const tooltipId = tooltipElement.id
    const owner = tooltipId
      ? document.querySelector(`[aria-describedby="${tooltipId}"]`)
      : null
    const ownerElement = owner as HTMLElement | null
    const isOwnerActive =
      ownerElement?.matches(':hover, :focus, :focus-visible') ?? false
    const isTooltipActive = tooltipElement.matches(':hover')
    const hasActiveOwner =
      ownerElement != null && document.contains(ownerElement)

    if (!hasActiveOwner && !isOwnerActive && !isTooltipActive) {
      hideTooltipElement(tooltip)
      return
    }

    if (!isOwnerActive && !isTooltipActive) {
      hideTooltipElement(tooltip)
    }
  })
}

export const useSyncfusionTooltipCleanup = (): void => {
  useEffect(() => {
    let cleanupFrame = 0
    const scheduleCleanup = (): void => {
      if (cleanupFrame !== 0) return
      cleanupFrame = window.requestAnimationFrame(() => {
        cleanupFrame = 0
        cleanupSyncfusionOrphanedTooltips()
      })
    }

    scheduleCleanup()
    document.addEventListener('pointerdown', scheduleCleanup, true)
    document.addEventListener('mousemove', scheduleCleanup, true)
    document.addEventListener('keydown', scheduleCleanup, true)
    document.addEventListener('scroll', scheduleCleanup, true)
    document.addEventListener('visibilitychange', scheduleCleanup)

    return () => {
      if (cleanupFrame !== 0) {
        window.cancelAnimationFrame(cleanupFrame)
      }
      cleanupSyncfusionOrphanedTooltips()
      document.removeEventListener('pointerdown', scheduleCleanup, true)
      document.removeEventListener('mousemove', scheduleCleanup, true)
      document.removeEventListener('keydown', scheduleCleanup, true)
      document.removeEventListener('scroll', scheduleCleanup, true)
      document.removeEventListener('visibilitychange', scheduleCleanup)
    }
  }, [])
}
